/**
 * Set to "true" to open the withdraw modal on load. The modal is mounted app
 * wide, so this works from any route.
 *
 * Must match the `withdrawalModal` key on `withdrawModalParams`, which is what
 * actually reads it. Kept in a leaf module so link builders can reference it
 * without pulling the modal, and the wizard behind it, into their bundle.
 */
export const WITHDRAWAL_MODAL_PARAM = "withdrawalModal";
